module.exports = __webpack_public_path__ + "static/img/banner_news_01.a80c3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/news/banner_news_01.png
// module id = dfJa
// module chunks = 10